const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

const pad = (n: number): string => String(n).padStart(2, '0');

/** "20 Oct 09:00" in the browser's timezone; "—" for a missing or invalid value. */
export function formatDateTime(value: string | number | Date | null | undefined): string {
  if (value === null || value === undefined || value === '') {
    return '—';
  }
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return '—';
  }
  return `${date.getDate()} ${MONTHS[date.getMonth()]} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

/**
 * How long ago `since` was, as a short figure for an overdue label: "under 1 h",
 * "3 h", then days once it passes two. Never negative.
 */
export function formatElapsed(since: string | number | Date, now: Date = new Date()): string {
  const ms = Math.max(0, now.getTime() - new Date(since).getTime());
  const hours = Math.floor(ms / 3_600_000);
  if (hours < 1) {
    return 'under 1 h';
  }
  if (hours < 48) {
    return `${hours} h`;
  }
  return `${Math.floor(hours / 24)} d`;
}
